import { createFileRoute } from "@tanstack/react-router";

import { LegalDocLayout } from "@/components/legal/LegalDocLayout";
import {
  TOKUSHOHO_ENTRIES,
  TOKUSHOHO_LAST_UPDATED,
  TOKUSHOHO_PREAMBLE,
} from "@/content/legal";

import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/tokushoho")({
  head: () => seoHead({
    title: "特定商取引法に基づく表記 - KAGEM",
    description: "KAGEMの販売事業者情報、運営責任者、所在地、価格、支払方法、商品の引渡時期、返金・解約条件、動作環境など、特定商取引法に基づく表記をまとめて掲載しています。",
    path: "/tokushoho",
  }),
  component: TokushohoPage,
});

function TokushohoPage() {
  // 単一テーブルなので目次は「表記事項」一項のみ
  const toc = [{ id: "tokushoho-table", label: "表記事項" }];

  return (
    <LegalDocLayout
      title="特定商取引法に基づく表記"
      preamble={TOKUSHOHO_PREAMBLE}
      lastUpdated={TOKUSHOHO_LAST_UPDATED}
      toc={toc}
    >
      <section id="tokushoho-table" className="legal-section scroll-mt-24">
        <div className="overflow-hidden rounded-lg border border-border">
          <dl className="divide-y divide-border">
            {TOKUSHOHO_ENTRIES.map((entry) => {
              const value =
                typeof entry.value === "function" ? entry.value() : entry.value;
              return (
                <div
                  key={entry.label}
                  className="grid grid-cols-1 gap-1 bg-card px-4 py-3 sm:grid-cols-[180px_1fr] sm:gap-4 sm:px-5 sm:py-4"
                >
                  <dt className="text-sm font-semibold text-foreground sm:pt-0.5">
                    {entry.label}
                  </dt>
                  <dd className="text-sm leading-relaxed text-foreground/90">
                    <p>{value}</p>
                    {entry.links && entry.links.length > 0 && (
                      <p className="mt-1.5 flex flex-wrap gap-x-3 gap-y-1 text-xs">
                        {entry.links.map((link) => {
                          const isExternal =
                            link.external ?? /^https?:\/\//.test(link.href);
                          return (
                            <a
                              key={link.href}
                              href={link.href}
                              target={isExternal ? "_blank" : undefined}
                              rel={isExternal ? "noopener noreferrer" : undefined}
                              className="text-primary underline-offset-2 hover:underline"
                            >
                              {link.label}
                              {isExternal ? " ↗" : " →"}
                            </a>
                          );
                        })}
                      </p>
                    )}
                    {entry.note && (
                      <p className="mt-1.5 text-xs text-muted-foreground">
                        {entry.note}
                      </p>
                    )}
                  </dd>
                </div>
              );
            })}
          </dl>
        </div>

      </section>
    </LegalDocLayout>
  );
}
